import { render, staticRenderFns } from "./StaffListWidget.vue?vue&type=template&id=0b4efe18&"
import script from "./StaffListWidget.vue?vue&type=script&lang=js&"
export * from "./StaffListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports